import logo from "assets/images/logo-color.svg";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-nfpa-expert-insights-label";

const NfpaInsightsLabel = () => {
    return (
        <span className={CSS_CLASS_NAME}>
            <img className={`${CSS_CLASS_NAME}__logo`} src={logo} alt="NFPA" />
            <span className={`${CSS_CLASS_NAME}__text`}>{t("insights")}</span>
        </span>
    );
};
export default NfpaInsightsLabel;
